<div [ngClass]="showLine ? 'collapsible' : ''">
	<button class="heading" (click)="isExpanded = !isExpanded; toggle()">
		<ng-content select="[heading]"></ng-content>

		<div class="action">
			<ng-content select="[action]"></ng-content>
			<div class="toggle" [class.active]="isExpanded">
				<bp-icon icon="chevron-up" />
			</div>
		</div>

		<ng-content select="[append]"></ng-content>
	</button>
	<div class="content" [class.active]="isExpanded">
		<ng-content></ng-content>
	</div>
</div>
